var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnmute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.33333L8.25833 5.075L10 6.81667V3.33333ZM3.55833 2.5L2.5 3.55833L6.44167 7.5H2.5V12.5H5.83333L10 16.6667V11.0583L13.5417 14.6083C12.9833 15.0333 12.3583 15.3833 11.6667 15.5833V17.3083C12.8167 17.0417 13.8583 16.5167 14.7333 15.8L16.4417 17.5L17.5 16.4417L10 8.94167L3.55833 2.5ZM15.8333 10C15.8333 10.7833 15.6667 11.5167 15.3833 12.2L16.6417 13.4583C17.1833 12.425 17.5 11.25 17.5 10C17.5 6.43333 15 3.45 11.6667 2.69167V4.40833C14.075 5.125 15.8333 7.35833 15.8333 10ZM13.75 10C13.75 8.525 12.9167 7.25833 11.6667 6.64167V8.48333L13.7083 10.525C13.75 10.3583 13.75 10.175 13.75 10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmute);
export default __webpack_public_path__ + "static/media/unmute.5d60078e4dd795b2e671c9372425c354.svg";
export { ForwardRef as ReactComponent };